import React from 'react'
import type { BankCardButton } from '../types'
import { PaymentMethodButtonStyled } from '../PaymentMethodButton.styled'
import { BankCardDisplay } from './BankCardDisplay'
import { makeAccessibleName } from './helpers'
import { AmericanExpress } from '../../Icons'

const issuerName = 'American Express'

export const AmericanExpressButton: BankCardButton = ({ lastFour, disabled, onClick }) => {
  return (
    <PaymentMethodButtonStyled
      provider='americanExpress'
      aria-label={makeAccessibleName(issuerName, lastFour)}
      disabled={disabled}
      onClick={onClick}
    >
      <AmericanExpress />
      <BankCardDisplay issuerName={issuerName} lastFour={lastFour} />
    </PaymentMethodButtonStyled>
  )
}
